<template>
  <v-row class="px-3" v-if="src">
    <v-col class="pa-0" cols="12">
      <v-sheet class="shadow half-radius" :class="{ pinkBackground: short }">
        <audio ref="audio" @timeupdate="onProgress" :src="src" />
        <v-row align="center" justify="center">
          <v-col cols="12" class="pb-0">
            <v-row :class="short && !taller ? '' : 'mt-3'" align="center" justify="center">
              <v-icon :color="short ? 'white' : ''" @click="onBack"
                >$vuetify.icons.appBackward</v-icon
              >
              <app-button
                :icon="icon"
                class="mx-4"
                @click.native="onClick"
                :size="short && !taller ? 30 : 48"
              />
              <v-icon :color="short ? 'white' : ''" @click="onForward"
                >$vuetify.icons.appForward</v-icon
              >
            </v-row>
          </v-col>
          <v-col cols="12" :class="{ 'mt-1 mb-3': !short, 'pt-0': short && !taller, upper: short }">
            <app-progress-bar
              v-model="progress"
              :duration="
                audio && audio.duration && audio.duration !== Infinity ? audio.duration : 0
              "
              class="mx-7"
              :background="short ? 'white' : ''"
              noCard
              @input="onInput"
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */
import Button from "./Button.vue";
import ProgressBar from "./ProgressBar.vue";
import audioMixin from "@/mixins/audioMixin";

export default {
  components: {
    appButton: Button,
    appProgressBar: ProgressBar,
  },
  props: {
    src: {
      type: String,
      required: false,
      default: "",
    },
    short: {
      type: Boolean,
      required: false,
      default: false,
    },
    taller: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [audioMixin],
  data() {
    return {
      audio: {
        duration: 0,
        currentTime: 0,
      },
      icon: "mdi-play",
      progress: 0,
    };
  },
  mounted() {
    this.audio = this.$refs.audio;
  },
  methods: {
    onClick() {
      if (this.audio.paused || this.audio.ended) {
        this.icon = "mdi-pause";
        this.$emit("play");
        this.audio.play();
      } else {
        this.icon = "mdi-play";
        this.$emit("pause");
        this.audio.pause();
      }
    },
    onInput() {
      this.audio.currentTime = this.progress;
    },
    onProgress() {
      this.progress = this.audio.currentTime;
      if (this.audio.currentTime === this.audio.duration) {
        this.icon = "mdi-play";
        this.$emit("pause");
        this.progress = 0;
      }
    },
    onBack() {
      this.audio.currentTime -= 5;
    },
    onForward() {
      this.audio.currentTime += 5;
    },
  },
};
</script>
<style scoped>
.pinkBackground {
  background: transparent linear-gradient(180deg, #ff2e7b 0%, #c71252 100%) 0% 0% no-repeat
    padding-box;
}
.upper {
  margin-top: -20px;
}
</style>
